// extracted by mini-css-extract-plugin
export default {"dashboard":"uSeX7g3n","report":"BYXxliRl"};